export default "__VITE_ASSET__cNQNGkSb__"